import './historyLink.scss';
import React from 'react';
import { Translate } from 'react-localize-redux';

class MoreLink extends React.Component {
    render() {
        if (this.props.noWrapper === true)
            return this.renderMoreLabel();

        return (
            <div className='bb-history-link'>
                <span onClick={this.props.onClick} className="link-functional">
                    {this.renderMoreLabel()}
                </span>
            </div>
        )
    }

    renderMoreLabel = () => {
        return this.props.moreExpanded === true ? <Translate id="Report.Common.Less" /> :  <Translate id="Report.Common.More" />
    }
}

export default MoreLink;